import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

import {MenuItemType} from '@models/sidebar/menu-item-type';

import {DesignService} from '@services/left-menu/design/design.service';
import {SelectPageService} from '@services/left-menu/select-page/select-page.service';
import {MenuItemComponent} from '@components/sidebar/menu-item/menu-item.component';
import {ExternalUrlService} from '@services/left-menu/page/external-url-page/external-url.service';
import {FramePageService} from '@services/left-menu/page/frame-page/frame-page.service';
import {ElasticMenuItem} from '@models/elasticSearch/menu/elastic-menu-item';
import {Observable} from 'rxjs';

@Component({
    selector: 'scitis-search-result-item',
    templateUrl: './search-result-item.component.html',
    styleUrls: ['./search-result-item.component.scss'],
    standalone: false
})
export class SearchResultItemComponent implements OnInit, OnChanges {

  @Input()
  menuItem: ElasticMenuItem = new ElasticMenuItem();

  @Input()
  searchTerms: string[] = [];

  @Output()
  menuItemSelected: EventEmitter<ElasticMenuItem> = new EventEmitter<ElasticMenuItem>();

  title: string = '';

  constructor(
      private designService: DesignService,
      private selectPageService: SelectPageService,
      private externalUrlService: ExternalUrlService,
      private framePageService: FramePageService) {
  }

  get parentName(): string {
    if (!this.menuItem.parentMenuItem) {
      return '';
    }

    return this.menuItem.parentMenuItem.name;
  }

  get getSearchResultItemActiveClass(): string {
    if (String(this.menuItem.id) === String(this.selectPageService.getSelectedPageId)) {
      return 'search-result-item-active';
    }
    return '';
  }

  private static getParentType(type: string): MenuItemType {
    const types: string[] = Object.values(MenuItemType);
    if (types.indexOf(type) > -1) {
      return MenuItemType[types[types.indexOf(type)]];
    }
    return MenuItemType.NONE;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.menuItem && changes.menuItem.currentValue) {
      this.menuItem.icon = this.designService.getIcon(this.menuItem.type);
      this.menuItem.parentMenuItem.icon = this.designService.getIcon(this.menuItem.parentMenuItem.type);
    }
  }

  ngOnInit() {
    if (this.menuItem.type === MenuItemType.EXTERNAL_URL || this.menuItem.type === MenuItemType.FRAME_PAGE) {
      const observable = this.getUrlObservable(this.menuItem);
      if (observable) {
        this.setUrl(observable);
      }
    }
  }

  onMenuItemSelected(menuItem: ElasticMenuItem): void {
    this.menuItemSelected.emit(menuItem);
  }

  getParentIcon() {
    if (!this.menuItem.parentMenuItem) {
      return '';
    }
    return this.designService.getIcon(SearchResultItemComponent.getParentType(this.menuItem.parentMenuItem.type)) + ' mr-1';
  }

  triggerMenuItemClick(event: any, menuItemComponent: MenuItemComponent): void {
    menuItemComponent.onMenuItemSelected(event);
  }

  private setUrl(observable: Observable<any>): void {
    observable.subscribe(urlResult => {
      if (this.menuItem.pageId === urlResult.id) {
        this.menuItem.url = urlResult.url;
      }
    });
  }

  private getUrlObservable(menuItem: ElasticMenuItem): Observable<any> | undefined {
    const isParentMachineGroup = menuItem.parentMenuItem.type === MenuItemType.MACHINE_GROUP;
    let parentId = menuItem.parentMenuItem.id;
    if (!parentId) {
      return;
    }

    if (parentId.indexOf('_') >= 0) {
      parentId = menuItem.parentMenuItem.id.split('_')[1];
    }

    if (menuItem.type === MenuItemType.EXTERNAL_URL && menuItem.pageId) {
      return this.externalUrlService.getExternalUrl(parentId, isParentMachineGroup, menuItem.pageId);
    }
    if (menuItem.type === MenuItemType.FRAME_PAGE && menuItem.pageId) {
      return this.framePageService.getFramePage(parentId, isParentMachineGroup, menuItem.pageId);
    }
    return undefined;
  }
}
